"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_PRODUCT_VALUE_ASSERTION = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.CREATE_PRODUCT_VALUE_ASSERTION = (0, gql_1.gql)(`
  mutation ProductAssertion($product: ProductAssertionInput!, $labelName: String!) {
    productAssertion(product: $product) {
      success
      error
      product {
        id
        productMetadata {
          lastAttributeUpdatedAt
          lastEditedBy {
            id
            name
          }
        }
        labels(first: 2000, filters: { label: { equals: $labelName } }) {
          edges {
            node {
              status
              label
              value
              origin
              explanation
            }
          }
        }
      }
    }
  }
`);
